import React, { useEffect, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import AdditionalInfoDiscountEdit from "./AdditionalInfoDiscountEdit";
import AdditionalInfoChargesEdit from "./AdditionalInfoChargesEdit";
import OfferMessageModal from "./OfferMessageModal";
import StoreLoadModal from "./StoreLoadModal";
import { getStoreLoad } from "../../services/Cart/BookNewOrder";
import { Button } from "primereact/button";
import { getLocalChargesAndDiscount, getStoreLocalData } from "../../utils/localStorage";
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";

const AdditionalInfo = ({
  storeId,
  processTime,
  sendDataToCartPage,
  totalPriceSum,
  userRole,
  // taxableAmount,
  totalGarmentCount,
  offerDiscountSum,
  removalChargeAndDiscountFunction,
  enabledCustomDiscountCharge,
  enabledChargeDiscountByService,
  storeGstNumber,
  autoChargeId,
  autoDiscountId,
  uniqueServices,
  enabledStoreLoad,
  docsScheduleValue,
  b2BModelSelected,
  enabledGSTControl,
  enabledAmountRoundOff,
  deliveryDateCutoffTime
}) => {

  const { storeLocalData } = getStoreLocalData();
  const [selectedItem, setSelectedItem] = useState(null);

  const [storeLoadModalVisible, setStoreLoadModalVisible] = useState(false);
  const [storeLoadData, setStoreLoadData] = useState([]);

  const [localAutoChargeId, setLocalAutoChargeId] = useState(autoChargeId);
  const [localAutoDiscountId, setLocalAutoDiscountId] =
    useState(autoDiscountId);

    const [isDocsScheduleValue, setIsDocsScheduleValue] = useState("");

  useEffect(() => {
    setLocalAutoChargeId(autoChargeId);
    setLocalAutoDiscountId(autoDiscountId);
  }, [autoChargeId, autoDiscountId]);


  //   Important: getHours() uses 24-hour time
// 0 → 12 AM
// 11 → 11 AM
// 12 → 12 PM
// 13 → 1 PM
// 23 → 11 PM
  
  const newProcessTime = deliveryDateCutoffTime > 0 && new Date().getHours() >= deliveryDateCutoffTime ? processTime + 1 : processTime

  const deliveryDate = new Date(
    new Date().getTime() + newProcessTime * 24 * 60 * 60 * 1000
  );
  
  const [date, setDate] = useState(deliveryDate);
  const [showPicker, setShowPicker] = useState(false);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const minimumDate = new Date();

  const handleItemPress = () => {
    setSelectedItem((prevSelectedItem) => !prevSelectedItem);
  };
  const [otherRemarkValue, setOtherRemarkValue] = useState("");
  const [addChargesValue, setAddChargesValue] = useState("");
  const [addDiscountValue, setAddDiscountValue] = useState("");
  const [isCheckedGST, setCheckedGST] = useState(
    storeGstNumber !== null && storeGstNumber !== "" ? true : false
  );
  const [isCheckedUrgentDelivery, setIsCheckedUrgentDelivery] = useState(false);
  const [isCheckedHomeDelivery, setCheckedHomeDelivery] = useState(
    userRole === "BY_RIDER" ? true : false
  );

  const [selectedCharges, setSelectedCharges] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState([]);

  const [charges, setCharges] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [
    additionalInfoDiscountEditModalVisible,
    setAdditionalInfoDiscountEditModalVisible,
  ] = useState(false);

  const [
    additionalInfoChargesEditModalVisible,
    setAdditionalInfoChargesEditModalVisible,
  ] = useState(false);

  const [discountAmountPreviousValue, setDiscountAmountPreviousValue] =
    useState({});

  const [chargeAmountPreviousValue, setChargeAmountPreviousValue] = useState(
    {}
  );

   useEffect(() => {
     setIsDocsScheduleValue(docsScheduleValue == "yes" ? true : false);
   }, [docsScheduleValue]);

   const fetchLocalChargesAndDiscount = async () => {
      const { chargesAndDiscount } = getLocalChargesAndDiscount();
      if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
        const [chargeArray, discountArray] = chargesAndDiscount.reduce(
          ([charges, discounts], item) => {
            if (
              item.chargeDiscountMode === "ALL" ||
              item.chargeDiscountMode === "BOOKING"
            ) {
              if (item.chargeDiscountType === "CHARGE") charges.push(item);
              if (item.chargeDiscountType === "DISCOUNT") discounts.push(item);
            }
            return [charges, discounts];
          },
          [[], []]
        );
        setCharges(chargeArray);
        setDiscounts(discountArray);
      } else {
        setCharges([]);
        setDiscounts([]);
      }
    };

  useEffect(() => {
    fetchLocalChargesAndDiscount();
  }, []);

  const addChargesData = charges.map((item, index) => ({
    id: index + 1,
    chargeDiscountId: item.id,
    name: item.name,
    amount: item.chargeDiscount,
    chargeDiscountType: item.chargeDiscountType,
    chargeDiscountTypeIn: item.chargeDiscountTypeIn,
    description: item.description,
    orderChargeDiscountMode: item.chargeDiscountMode,
  }));

  const addDiscountsData = discounts.map((item, index) => ({
    id: index + 1,
    chargeDiscountId: item.id,
    name: item.name,
    amount: item.chargeDiscount,
    chargeDiscountType: item.chargeDiscountType,
    chargeDiscountTypeIn: item.chargeDiscountTypeIn,
    description: item.description,
    orderChargeDiscountMode: item.chargeDiscountMode,
  }));

  const handleOtherRemarkChange = (text) => {
    setOtherRemarkValue(text);
  };

  const toggleDatePicker = () => {
    setShowPicker(!showPicker);
  };
  {
    /* add charges */
  }

  const calculateExistingDiscounts = () => {
    return selectedDiscount.reduce((sum, discount) => {
      // if (discount.chargeDiscountTypeIn === 'AMOUNT') {
      //   return sum + discount.amount;
      // } else if (discount.chargeDiscountTypeIn === 'PERCENTAGE') {
      //   return sum + (totalPriceSum * discount.amount) / 100;
      // }
      // return sum + discount.amount;
      return sum + (discount.calculatedAmount || 0);
    }, 0);
  };

  const addCharge = (charge) => {
    // Check if the charge is not already in the selectedCharges array
    if (
      !selectedCharges.some((selectedCharge) => selectedCharge.id === charge.id)
    ) {
      // Add the charge to the selectedCharges array
      // setSelectedCharges([...selectedCharges, charge]);
      const calculatedAmount =
        charge.chargeDiscountTypeIn === "PERCENTAGE"
          ? Number(((totalPriceSum * charge.amount) / 100)?.toFixed(enabledAmountRoundOff))
          : Number(charge.amount?.toFixed(enabledAmountRoundOff));

      const newCharge = {
        ...charge,
        amount: calculatedAmount,
        calculatedAmount,
        count: parseInt(charge?.count),
        originalAmount: parseInt(charge?.amount?.toFixed(0)),
      };
      // Add the charge to the selectedCharges array
      setSelectedCharges([...selectedCharges, newCharge]);
    }
  };

  const addChargeAutoCharge = (charge) => {
    // Check if the charge is not already in the selectedCharges array
    if (
      !selectedCharges.some((selectedCharge) => selectedCharge.id === charge.id)
    ) {
      const newCharge = {
        ...charge,
        count: parseInt(1),
        originalAmount: parseInt(charge?.amount?.toFixed(0)),
      };
      // Add the charge to the selectedCharges array
      setSelectedCharges([...selectedCharges, newCharge]);
    }
  };

  const addPercentageCharge = (charge) => {
    // Check if the charge is not already in the selectedCharges array
    if (
      !selectedCharges.some((selectedCharge) => selectedCharge.id === charge.id)
    ) {
      const calculatedAmount =
        charge.chargeDiscountTypeIn === "PERCENTAGE"
          ? Number(((totalPriceSum * charge.amount) / 100)?.toFixed(enabledAmountRoundOff))
          : Number(charge.amount?.toFixed(enabledAmountRoundOff));

      const newCharge = {
        ...charge,
        amount: calculatedAmount,
        calculatedAmount,
        count: parseInt(1),
        originalAmount: parseInt(charge?.amount?.toFixed(0)),
      };
      // Add the charge to the selectedCharges array
      setSelectedCharges([...selectedCharges, newCharge]);
    }
  };

  const addChargesConfirmation = (charge) => {
    // let newDiscountAmount;
    // if (charge.chargeDiscountTypeIn === 'AMOUNT') {
    //   newDiscountAmount = charge.amount;
    // } else if (charge.chargeDiscountTypeIn === 'PERCENTAGE') {
    //   newDiscountAmount = (totalPriceSum * charge.amount) / 100;
    // }

    // Calculate NEW charge amount
    const newDiscountAmount =
      charge.chargeDiscountTypeIn === "PERCENTAGE"
        ? Number(((totalPriceSum * charge.amount) / 100)?.toFixed(enabledAmountRoundOff))
        : Number(charge.amount?.toFixed(enabledAmountRoundOff));

    // Prevent duplicates using chargeDiscountId
    const isDuplicate = selectedCharges.some(
      (d) => d.chargeDiscountId === charge.chargeDiscountId
    );

    if (isDuplicate) return;

    // Store ORIGINAL + CALCULATED amounts
    const newCharge = {
      ...charge,
      originalAmount: charge.amount, // keep original (for recalculation)
      calculatedAmount: newDiscountAmount, // dynamic value used in totals
      count: 1,
    };

    // Pass newly formatted discount to modal
    
    // if (
    //   !selectedCharges.some((selectedCharge) => selectedCharge.id === charge.id)
    // ) {
      // const newCharge = {charge};
      setChargeAmountPreviousValue(newCharge);
      setAdditionalInfoChargesEditModalVisible(true);
    // }
  };

  const handleAddChargesChange = (charge) => {
    setAddChargesValue(charge.name);
    if (
      enabledChargeDiscountByService &&
      charge.chargeDiscountTypeIn === "AMOUNT"
    ) {
      addChargesConfirmation(charge);
    } else {
      addPercentageCharge(charge);
    }
  };
  const dropdownItems = addChargesData.filter(
    (charge) =>
      !selectedCharges.some((selectedCharge) => selectedCharge.id === charge.id)
  );
  {
    /* add Discount */
  }

  // const addDiscount = discount => {
  //   if (
  //     !selectedDiscount.some(
  //       selectedDiscount => selectedDiscount.id === discount.id,
  //     )
  //   ) {
  //     // Add the charge to the selectedCharges array
  //     setSelectedDiscount([...selectedDiscount, discount]);
  //   }
  // };

  const receiveDataFromCustomAmountModal = ({
    success,
    customDiscountValue,
  }) => {
    if (success) {
      addDiscount(customDiscountValue);
    }
  };

  const receiveDataFromCustomChargeAmountModal = ({
    success,
    customChargeValue,
  }) => {
    if (success) {
      addCharge(customChargeValue);
    }
  };

  const [messageDisplay, setMessageDisplay] = useState(false);
  const [messageText, setMessageText] = useState("");

  const addDiscount = (discount) => {
    const taxableAmount = calculateTaxableAmount();
    const existing = calculateExistingDiscounts();

    const calculatedAmount =
      discount.chargeDiscountTypeIn === "PERCENTAGE"
        ? Number(((totalPriceSum * discount.amount) / 100)?.toFixed(enabledAmountRoundOff))
        : Number(discount.amount?.toFixed(enabledAmountRoundOff));

    // validate
    if (taxableAmount < existing + calculatedAmount) {
      setMessageDisplay(true);
      setMessageText("This Discount Can't be added");
      return;
    }

    if (
      !selectedDiscount.some(
        (d) => d.chargeDiscountId === discount.chargeDiscountId
      )
    ) {
      setSelectedDiscount((prev) => [
        ...prev,
        {
          ...discount,
          amount: calculatedAmount,
          count: parseInt(1),
          originalAmount: discount.amount, // save percentage or amount
          calculatedAmount, // dynamic calculated value
        },
      ]);
    }
  };


  // const addDiscount = (discount) => {
  //   const existingDiscounts = calculateExistingDiscounts();
  //   const taxableAmount = calculateTaxableAmount();
  //   let newDiscountAmount;
  //   if (
  //     // enabledCustomDiscountCharge === false &&
  //     discount.chargeDiscountTypeIn === "PERCENTAGE"
  //   ) {
  //     newDiscountAmount = Math.round((totalPriceSum * discount.amount) / 100);
  //   } else {
  //     newDiscountAmount = Math.round(discount.amount);
  //   }
  //   // if (discount.chargeDiscountTypeIn === 'AMOUNT') {
  //   //   newDiscountAmount = discount.amount;
  //   // } else if (discount.chargeDiscountTypeIn === 'PERCENTAGE') {
  //   //   newDiscountAmount = (totalPriceSum * discount.amount) / 100;
  //   // }

  //   if (taxableAmount >= existingDiscounts + newDiscountAmount) {
  //     if (
  //       !selectedDiscount.some(
  //         (selectedDiscount) => selectedDiscount.id === discount.id
  //       )
  //     ) {
  //       const newDiscount = {
  //         ...discount,
  //         count: parseInt(1),
  //         amount: Math.round(newDiscountAmount),
  //       };
  //       setSelectedDiscount([...selectedDiscount, newDiscount]);
  //     }
  //   } else {
  //     setAddDiscountValue("");
  //     setMessageDisplay(true);
  //     setMessageText("This Discount Can't be added");
  //     // alert("This Offer Can't be added");
  //   }
  // };

  const addDiscountConfirmation = (discount) => {
    const existingDiscounts = calculateExistingDiscounts();
    const taxableAmount = calculateTaxableAmount();

    // Calculate NEW discount amount
    const newDiscountAmount =
      discount.chargeDiscountTypeIn === "PERCENTAGE"
        ? Number(((totalPriceSum * discount.amount) / 100)?.toFixed(enabledAmountRoundOff))
        : Number(discount.amount?.toFixed(enabledAmountRoundOff));

    // Check limit (taxable must be >= current + new)
    if (taxableAmount < existingDiscounts + newDiscountAmount) {
      setAddDiscountValue("");
      setMessageDisplay(true);
      setMessageText("This Discount Can't be added");
      return;
    }

    // Prevent duplicates using chargeDiscountId
    const isDuplicate = selectedDiscount.some(
      (d) => d.chargeDiscountId === discount.chargeDiscountId
    );

    if (isDuplicate) return;

    // Store ORIGINAL + CALCULATED amounts
    const newDiscount = {
      ...discount,
      originalAmount: discount.amount, // keep original (for recalculation)
      calculatedAmount: newDiscountAmount, // dynamic value used in totals
      count: 1,
    };

    // Pass newly formatted discount to modal
    setDiscountAmountPreviousValue(newDiscount);
    setAdditionalInfoDiscountEditModalVisible(true);
  };


  // const addDiscountConfirmation = (discount) => {
  //   const existingDiscounts = calculateExistingDiscounts();
  //   const taxableAmount = calculateTaxableAmount();
  //   let newDiscountAmount;
  //   if (discount.chargeDiscountTypeIn === "AMOUNT") {
  //     newDiscountAmount = Math.round(discount.amount);
  //   } else if (discount.chargeDiscountTypeIn === "PERCENTAGE") {
  //     newDiscountAmount = Math.round((totalPriceSum * discount.amount) / 100);
  //   }
  //   if (taxableAmount >= existingDiscounts + newDiscountAmount) {
  //     if (
  //       !selectedDiscount.some(
  //         (selectedDiscount) => selectedDiscount.id === discount.id
  //       )
  //     ) {
  //       const newDiscount = {
  //         ...discount,
  //         count: parseInt(1),
  //         amount: Math.round(newDiscountAmount),
  //       };
  //       setDiscountAmountPreviousValue(newDiscount);
  //       setAdditionalInfoDiscountEditModalVisible(true);
  //     }
  //   } else {
  //     setAddDiscountValue("");
  //     setMessageDisplay(true);
  //     setMessageText("This Discount Can't be added");
  //     // alert("This Offer Can't be added");
  //   }
  // };

  const handleAddDiscountChange = (discount) => {
    setAddDiscountValue(discount.name);
    if (
      enabledCustomDiscountCharge &&
      discount.chargeDiscountTypeIn === "AMOUNT"
    ) {
      addDiscountConfirmation(discount);
    } else {
      addDiscount(discount);
    }
  };

  // const removeDiscount = (discountToRemove) => {
  //   const updatedDiscounts = selectedDiscount.filter(
  //     (item) => item !== discountToRemove
  //   );
  //   setSelectedDiscount(updatedDiscounts);
  //   const taxableAmountFormRemoveCharges = calculateTaxableAmount();
  // };

  const removeDiscount = (discountToRemove) => {
    const updatedDiscounts = selectedDiscount.filter(
      (item) => item.chargeDiscountId !== discountToRemove.chargeDiscountId
    );
    setSelectedDiscount(updatedDiscounts);
    // If the removed discount matches `localAutoDiscountId`, reset it to null
    if (discountToRemove.chargeDiscountId === localAutoDiscountId) {
      setLocalAutoDiscountId(null);
      setAddDiscountValue("");
    }
    const taxableAmountFormRemoveCharges = calculateTaxableAmount();
  };

  const dropdownItemsDiscount = addDiscountsData.filter(
    (discount) =>
      !selectedDiscount.some(
        (selectedDiscount) => selectedDiscount.id === discount.id
      )
  );

  const getChargeDiscountSymbol = (type) => {
    switch (type) {
      case "AMOUNT":
        return storeLocalData?.currencySymbol ; // You can use any symbol you prefer for Amount
      case "PERCENTAGE":
        return "%"; // Use '%' symbol for PERCENTAGE
      default:
        return "";
    }
  };

  const calculateAdditionalCharges = () => {
    let additionalCharges = 0;
    let additionalDiscounts = 0;

    selectedCharges.forEach((charge) => {
      additionalCharges += Number(charge.calculatedAmount || 0);
      // if (charge.chargeDiscountTypeIn === "AMOUNT") {
      //   additionalCharges += charge.amount;
      // } else if (charge.chargeDiscountTypeIn === "PERCENTAGE") {
      //   additionalCharges += (totalPriceSum * charge.amount) / 100;
      // }
    });

    selectedDiscount.forEach((discount) => {
      // additionalDiscounts += discount.amount;
      additionalDiscounts += Number(discount.calculatedAmount || 0);
      // if (discount.chargeDiscountTypeIn === 'AMOUNT') {
      //   additionalDiscounts += discount.amount;
      // } else if (discount.chargeDiscountTypeIn === 'PERCENTAGE') {
      //   additionalDiscounts += (totalPriceSum * discount.amount) / 100;
      // }
    });

    return {
      additionalCharges,
      additionalDiscounts,
    };
  };

  const updateChargesWithPercentage = () => {
    const updatedCharges = selectedCharges.map((charge) => {
      // if (charge.chargeDiscountTypeIn === "PERCENTAGE") {
      // Calculate the updated amount based on the percentage
      // const updatedAmount = (totalPriceSum * charge.amount) / 100;
      // return { ...charge, amount: Math.round(updatedAmount) };
      // }
      return charge;
    });
    return updatedCharges;
  };

  const updateDiscountWithPercentage = () => {
    const updatedDiscounts = selectedDiscount.map((discount) => {
      // if (discount.chargeDiscountTypeIn === 'PERCENTAGE') {
      //   // Calculate the updated amount based on the percentage
      //   const updatedAmount = (totalPriceSum * discount.amount) / 100;
      //   return {...discount, amount: Math.round(updatedAmount)};
      // }
      return discount;
    });
    return updatedDiscounts;
  };

  const [updatedCharges, setUpdatedCharges] = useState(selectedCharges);
  const [updatedDiscounts, setUpdatedDiscounts] = useState(selectedDiscount);

  useEffect(() => {

    const newCharges = selectedCharges.map((charge) => {
      const updatedAmount =
        charge.chargeDiscountTypeIn === "PERCENTAGE"
          ? Number(((totalPriceSum * charge.originalAmount) / 100)?.toFixed(enabledAmountRoundOff))
          : Number(charge.originalAmount?.toFixed(enabledAmountRoundOff));

      return {
        ...charge,
        calculatedAmount: updatedAmount,
      };
    });

    setSelectedCharges(newCharges);

    const newDiscounts = selectedDiscount.map((discount) => {
      const updatedAmount =
        discount.chargeDiscountTypeIn === "PERCENTAGE"
          ? Number(((totalPriceSum * discount.originalAmount) / 100)?.toFixed(enabledAmountRoundOff))
          : Number(discount.originalAmount?.toFixed(enabledAmountRoundOff));

      return {
        ...discount,
        calculatedAmount: updatedAmount,
      };
    });

    setSelectedDiscount(newDiscounts);
  // }, [totalPriceSum, offerDiscountSum, selectedCharges, selectedDiscount]);
}, [totalPriceSum, offerDiscountSum]);

  // Update charges whenever totalPriceSum changes
  useEffect(() => {
    const newCharges = updateChargesWithPercentage();
    setUpdatedCharges(newCharges);
    const newDiscounts = updateDiscountWithPercentage();
    setUpdatedDiscounts(newDiscounts);
  }, [totalPriceSum, selectedCharges, selectedDiscount]);

  const { additionalCharges, additionalDiscounts } =
    calculateAdditionalCharges();
  const totalCharges = additionalCharges - additionalDiscounts;

  const calculateTaxableAmount = () => {
    const { additionalCharges, additionalDiscounts } =
      calculateAdditionalCharges();
    return (
      totalPriceSum + additionalCharges - additionalDiscounts - offerDiscountSum
    );
  };

  const taxableAmountFormRemoveCharges = calculateTaxableAmount();

  useEffect(() => {
    if (taxableAmountFormRemoveCharges < 0) {
      setSelectedDiscount([]);
    }
  }, [taxableAmountFormRemoveCharges]);

  useEffect(() => {
    if (removalChargeAndDiscountFunction) {
      setSelectedDiscount([]);
      setSelectedCharges([]);
    } 
    if (totalGarmentCount === 0) {
      setSelectedDiscount([]);
      setSelectedCharges([]);
    }
  }, [removalChargeAndDiscountFunction, totalGarmentCount]);

  // const removeCharge = (chargeToRemove) => {
  //   const updatedCharges = selectedCharges.filter(
  //     (item) => item !== chargeToRemove
  //   );
  //   setSelectedCharges(updatedCharges);
  // };

  const removeCharge = (chargeToRemove) => {
    const updatedCharges = selectedCharges.filter(
      (item) => item.chargeDiscountId !== chargeToRemove.chargeDiscountId
    );
    setSelectedCharges(updatedCharges);
    // If the removed charge matches `localAutoChargeId`, reset it to null
    if (chargeToRemove.chargeDiscountId === localAutoChargeId) {
      setLocalAutoChargeId(null);
      setAddChargesValue("");
    }
  };

  // useEffect(() => {
  //   if (!addChargesData.length && !addDiscountsData.length) return;

  //   const processAutoItems = () => {
  //     // ------------------ AUTO CHARGE ------------------
  //     if (localAutoChargeId) {
  //       const autoCharge = addChargesData.find(
  //         (c) => c.chargeDiscountId === localAutoChargeId
  //       );

  //       if (autoCharge) {
  //         // Add only if not already added
  //         setSelectedCharges((prev) => {
  //           if (
  //             prev.some(
  //               (c) => c.chargeDiscountId === autoCharge.chargeDiscountId
  //             )
  //           )
  //             return prev;

  //           return [
  //             ...prev,
  //             {
  //               ...autoCharge,
  //               originalAmount: autoCharge.amount,
  //               calculatedAmount: autoCharge.amount, // you may compute here if PERCENTAGE
  //               count: 1,
  //             },
  //           ];
  //         });

  //         setAddChargesValue(autoCharge.name);
  //       }
  //     }

  //     // ------------------ AUTO DISCOUNT ------------------
  //     if (localAutoDiscountId) {
  //       const autoDiscount = addDiscountsData.find(
  //         (d) => d.chargeDiscountId === localAutoDiscountId
  //       );

  //       if (autoDiscount) {
  //         setSelectedDiscount((prev) => {
  //           if (
  //             prev.some(
  //               (d) => d.chargeDiscountId === autoDiscount.chargeDiscountId
  //             )
  //           )
  //             return prev;

  //           return [
  //             ...prev,
  //             {
  //               ...autoDiscount,
  //               originalAmount: autoDiscount.amount,
  //               calculatedAmount: autoDiscount.amount, // recalculated later
  //               count: 1,
  //             },
  //           ];
  //         });

  //         setAddDiscountValue(autoDiscount.name);
  //       }
  //     }
  //   };

  //   processAutoItems();
  // }, [
  //   localAutoChargeId,
  //   localAutoDiscountId,
  //   addChargesData,
  //   addDiscountsData,
  // ]);


  // useEffect(() => {
  //   const processChargesAndDiscounts = async () => {
  //     // Process Charges
  //     const autoChargeIdValue = addChargesData.find(
  //       (charge) => localAutoChargeId === charge.chargeDiscountId
  //     );

  //     if (autoChargeIdValue) {
  //       setAddChargesValue(autoChargeIdValue.name);
  //       await addChargeAutoCharge(autoChargeIdValue);
  //     }

  //     // Ensure `addDiscountsData` is populated before processing
  //     if (!addDiscountsData || addDiscountsData.length === 0) {
  //       console.warn("addDiscountsData is empty, retrying...");
  //       return;
  //     }

  //     // Process Discounts
  //     const autoDiscountIdValue = addDiscountsData.find(
  //       (discount) => localAutoDiscountId === discount.chargeDiscountId
  //     );

  //     if (autoDiscountIdValue) {
  //       const existingDiscounts = calculateExistingDiscounts();
  //       const taxableAmount = calculateTaxableAmount();

  //       const addDiscountWithValues = (discount) => {
  //         let newDiscountAmount =
  //           // !enabledCustomDiscountCharge &&
  //           discount.chargeDiscountTypeIn === "PERCENTAGE"
  //             ? (totalPriceSum * discount.amount) / 100
  //             : discount.amount;

  //         if (taxableAmount >= existingDiscounts + newDiscountAmount) {
  //           if (
  //             !selectedDiscount.some(
  //               (selectedDiscount) => selectedDiscount.id === discount.id
  //             )
  //           ) {
  //             if (newDiscountAmount > 0) {
  //               setSelectedDiscount((prevDiscounts) => {
  //                 const discountExists = prevDiscounts.some(
  //                   (selectedDiscount) =>
  //                     selectedDiscount.chargeDiscountId ===
  //                     discount.chargeDiscountId
  //                 );
  //                 if (!discountExists) {
  //                   const newDiscount = {
  //                     ...discount,
  //                     count: parseInt(1),
  //                     amount: Math.round(newDiscountAmount),
  //                   };
  //                   setAddDiscountValue(autoDiscountIdValue.name);
  //                   return [...prevDiscounts, newDiscount];
  //                 }
  //                 return prevDiscounts; // Return unchanged if duplicate found
  //               });
  //             }
  //           }
  //         } else {
  //           setAddDiscountValue("");
  //         }
  //       };

  //       addDiscountWithValues(autoDiscountIdValue);
  //     }
  //   };

  //   // if (addChargesData.length > 0 && addDiscountsData.length > 0) {
  //   //   processChargesAndDiscounts();
  //   // }
  //   if (addChargesData.length > 0) {
  //     processChargesAndDiscounts();
  //   }
  //   if (addDiscountsData.length > 0) {
  //     processChargesAndDiscounts();
  //   }
  // }, [
  //   localAutoChargeId,
  //   localAutoDiscountId,
  //   addChargesData,
  //   addDiscountsData,
  // ]);


  useEffect(() => {
    // Data not ready yet
    if (!addChargesData.length && !addDiscountsData.length) return;

    const processAutoItems = () => {
      // ---------------------------- AUTO CHARGE ----------------------------
      if (localAutoChargeId) {
        const autoCharge = addChargesData.find(
          (c) => c.chargeDiscountId === localAutoChargeId
        );

        if (autoCharge) {
          setSelectedCharges((prev) => {
            const exists = prev.some(
              (c) => c.chargeDiscountId === autoCharge.chargeDiscountId
            );
            if (exists) return prev;

            const calculatedAmount =
              autoCharge.chargeDiscountTypeIn === "PERCENTAGE"
                ? Number(((totalPriceSum * autoCharge.amount) / 100)?.toFixed(enabledAmountRoundOff))
                : Number(autoCharge.amount?.toFixed(enabledAmountRoundOff));

            return [
              ...prev,
              {
                ...autoCharge,
                amount: calculatedAmount,
                originalAmount: autoCharge.amount,
                calculatedAmount,
                count: 1,
              },
            ];
          });

          setAddChargesValue(autoCharge.name);
        }
      }

      // ---------------------------- AUTO DISCOUNT ----------------------------
      if (localAutoDiscountId) {
        const autoDiscount = addDiscountsData.find(
          (d) => d.chargeDiscountId === localAutoDiscountId
        );

        if (autoDiscount) {
          setSelectedDiscount((prev) => {
            const exists = prev.some(
              (d) => d.chargeDiscountId === autoDiscount.chargeDiscountId
            );
            if (exists) return prev;

            // temporary calculated amount – will be updated later in recalc useEffect
            const calculatedAmount =
              autoDiscount.chargeDiscountTypeIn === "PERCENTAGE"
                ? Number(((totalPriceSum * autoDiscount.amount) / 100)?.toFixed(enabledAmountRoundOff))
                : Number(autoDiscount.amount?.toFixed(enabledAmountRoundOff));

            return [
              ...prev,
              {
                ...autoDiscount,
                amount: calculatedAmount,
                originalAmount: autoDiscount.amount, // store original value
                calculatedAmount, // dynamic value
                count: 1,
              },
            ];
          });

          setAddDiscountValue(autoDiscount.name);
        }
      }
    };

    processAutoItems();
  }, [
    localAutoChargeId,
    localAutoDiscountId,
    addChargesData,
    addDiscountsData,
  ]);

  if (b2BModelSelected) {
    sendDataToCartPage({
      totalCharges: 0,
      additionalCharges: 0,
      additionalDiscounts: 0,
      selectedCharges: [],
      selectedDiscount: [],
      updatedCharges: [],
      updatedDiscounts : [],
      date,
      isCheckedGST,
      isCheckedHomeDelivery,
      isCheckedUrgentDelivery,
      otherRemarkValue,
      isDocsScheduleValue,
    });
  } else {
    sendDataToCartPage({
      totalCharges,
      additionalCharges,
      additionalDiscounts,
      selectedCharges,
      selectedDiscount,
      updatedCharges,
      updatedDiscounts,
      date,
      isCheckedGST,
      isCheckedHomeDelivery,
      isCheckedUrgentDelivery,
      otherRemarkValue,
      isDocsScheduleValue,
    });
  }

  
  
  const checkStoreLoad = () => {
    const currentTime = new Date();
    date?.setHours(
      currentTime.getHours(),
      currentTime.getMinutes(),
      currentTime.getSeconds(),
      currentTime.getMilliseconds()
    );

    const newDate = new Date(date);
    const currentDateTime = newDate.toISOString();

    const loadData = {
      storeId: storeId,
      statusIn: ["BOOKED", "INPROCESS", "IN_WAREHOUSE", "PROCESSED"],
      // serviceIn: uniqueServices,
      startDate: localeDateStartDate(new Date(currentDateTime)),
      endDate: localeDateEndDate(new Date(currentDateTime)),
    };

    getStoreLoad(loadData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreLoadModalVisible(true);
          setStoreLoadData({
            loadData: Res,
            date: currentDateTime,
          });
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  return (
    <div
      className="flex-1 shadow-2 px-3 mb-2"
      style={{
        backgroundColor: "#F6FAFF",
      }}
    >
      <div
        className={
          "flex flex-1 justify-content-between mx-2 py-2 cursor-pointer"
        }
        onClick={() => handleItemPress()}
      >
        <div className="flex justify-content-start align-items-center flex-1 ">
          <img
            src={"Laundy_App_Icons_Gifs/Other_Icons/Payment_Details.png"}
            resizeMode="cover"
            style={{
              width: 20,
              height: 20,
            }}
          />
          <p className=" text-lg font-medium capitalize ml-2">
            Additional Information
          </p>
        </div>
        <div>
          {!selectedItem ? (
            <i
              className="pi pi-angle-down"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          ) : (
            <i
              className="pi pi-angle-up"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          )}
        </div>
      </div>

      {selectedItem && (
        <div
          className="my-2 border-top-2"
          style={{
            borderTopColor: "#C1C9D3",
          }}
        >
          {!b2BModelSelected  &&
            <div className="flex-1 mx-2 mb-1 mt-3">
            <div
              className="border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <Dropdown
                value={addChargesValue}
                onChange={(e) => handleAddChargesChange(e.value)}
                options={dropdownItems}
                optionLabel="name"
                placeholder="Add Charges"
                className="w-full  bg-white-alpha-20  text-2xl text-primary-50"
              />
            </div>
          </div>}
          {/* <p>
                    {item.name} | {item.amount} |{" "}
                    {getChargeDiscountSymbol(item.chargeDiscountTypeIn)}
                  </p> */}

          {!b2BModelSelected && selectedCharges.map((charge, index) => (
            <React.Fragment>
              <div
                key={index}
                className="px-4 py-1 mt-3"
                style={{
                  backgroundColor: "#fff7d1",
                }}
              >
                <p className=" text-lg font-medium capitalize">
                  {charge.name} | {Number(charge.calculatedAmount?.toFixed(enabledAmountRoundOff))} |{" "}
                  {/*getChargeDiscountSymbol(charge.chargeDiscountTypeIn)*/}{storeLocalData?.currencySymbol}
                </p>

                <p
                  className=" text-lg  capitalize"
                  style={{ color: "#828487" }}
                >
                  Description: {charge.description} | Amount In:{" "}
                  {getChargeDiscountSymbol(charge.chargeDiscountTypeIn)}
                </p>
              </div>
              <div
                className="flex flex-row justify-content-end align-items-center my-1 mx-2 cursor-pointer"
                onClick={() => removeCharge(charge)}
              >
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/Remove.png"}
                  style={{
                    width: 12,
                    height: 12,
                  }}
                />

                <p
                  className=" text-md font-normal capitalize ml-2"
                  style={{ color: "red" }}
                >
                  Remove
                </p>
              </div>
            </React.Fragment>
          ))}

          {!b2BModelSelected && <div className="flex-1 mx-2 mb-1 mt-3">
            <div
              className="border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <Dropdown
                value={addDiscountValue}
                onChange={(e) => handleAddDiscountChange(e.value)}
                options={dropdownItemsDiscount}
                optionLabel="name"
                placeholder="Add Discount"
                className="w-full  bg-white-alpha-20  text-2xl text-primary-50"
              />
            </div>
          </div>}
          {/* <p>
                    {item.name} | {item.amount} |{" "}
                    {getChargeDiscountSymbol(item.chargeDiscountTypeIn)}
                  </p> */}

          {!b2BModelSelected && selectedDiscount.map((discount, index) => (
            <React.Fragment>
              <div
                key={index}
                className="px-4 py-1 mt-3"
                style={{
                  backgroundColor: "#fff7d1",
                }}
              >
                <p className=" text-lg font-medium capitalize">
                  {discount.name} | {Number(discount.calculatedAmount?.toFixed(enabledAmountRoundOff))} |{" "}
                  {/*getChargeDiscountSymbol(discount.chargeDiscountTypeIn)*/}{storeLocalData?.currencySymbol}
                </p>

                <p
                  className=" text-lg  capitalize"
                  style={{ color: "#828487" }}
                >
                  Description: {discount.description} | Amount In:{" "}
                  {getChargeDiscountSymbol(discount.chargeDiscountTypeIn)}
                </p>
              </div>
              <div
                className="flex flex-row justify-content-end align-items-center my-1 mx-2 cursor-pointer"
                onClick={() => removeDiscount(discount)}
              >
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/Remove.png"}
                  style={{
                    width: 12,
                    height: 12,
                  }}
                />

                <p
                  className=" text-md font-normal capitalize ml-2"
                  style={{ color: "red" }}
                >
                  Remove
                </p>
              </div>
            </React.Fragment>
          ))}

          {storeGstNumber !== null && storeGstNumber !== "" && (
            <div className="flex-1 mx-2 mb-1 mt-3">
              <div
                className="border-round-lg shadow-2 flex px-3 py-2 justify-content-between"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <p
                  className=" text-md font-normal capitalize"
                  style={{ color: "#6b7280" }}
                >
                  {storeLocalData?.taxType}
                </p>
                <div>
                  <Checkbox
                    onChange={() => setCheckedGST(!isCheckedGST)}
                    checked={isCheckedGST}
                    disabled={enabledGSTControl ? false : true}
                  ></Checkbox>
                </div>
              </div>
            </div>
          )}

          {!b2BModelSelected && <div className="flex-1 mx-2 mb-1 mt-3">
            <div
              className="border-round-lg shadow-2 flex px-3 py-2 justify-content-between"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <p
                className=" text-md font-normal capitalize"
                style={{ color: "#6b7280" }}
              >
                HOME DELIVERY
              </p>
              <div>
                <Checkbox
                  onChange={() =>
                    setCheckedHomeDelivery(!isCheckedHomeDelivery)
                  }
                  checked={isCheckedHomeDelivery}
                ></Checkbox>
              </div>
            </div>
          </div>}

          {!b2BModelSelected && <div className="flex-1 mx-2 mb-1 mt-3">
            <div
              className="border-round-lg shadow-2 flex px-3 py-2 justify-content-between"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <p
                className=" text-md font-normal capitalize"
                style={{ color: "#6b7280" }}
              >
                Urgent Delivery
              </p>
              <div>
                <Checkbox
                  checked={isCheckedUrgentDelivery}
                  onChange={() =>
                    setIsCheckedUrgentDelivery(!isCheckedUrgentDelivery)
                  }
                ></Checkbox>
              </div>
            </div>
          </div>}

          {/*userRole === "BY_STORE" && (
            <div className="flex-1 mx-2 mb-1 mt-3">
              <div
                className="border-round-lg shadow-2 flex px-3 py-2 justify-content-between"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <p
                  className=" text-md font-normal capitalize"
                  style={{ color: "#6b7280" }}
                >
                  Docs Scheduled
                </p>
                <div>
                  <Checkbox
                    checked={isDocsScheduleValue}
                    onChange={() =>
                      setIsDocsScheduleValue(!isDocsScheduleValue)
                    }
                  ></Checkbox>
                </div>
              </div>
            </div>
          )*/}

          <div className="flex-1 mx-2 mb-1 mt-3">
            <div
              className="border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            >
              <InputText
                placeholder="Order Remark"
                value={otherRemarkValue}
                maxLength={250}
                onChange={(e) => handleOtherRemarkChange(e.target.value)}
                className=" border-none px-3 text-md w-full"
              ></InputText>
            </div>
          </div>

          <div className="flex">
            <div className="flex-auto">
              <label
                htmlFor="Delivery"
                className="font-bold block mx-3 mt-2"
                // style={{
                //   backgroundColor: "#fff",
                // }}
              >
                Delivery Date
              </label>
              <Calendar
                id="Delivery"
                value={date}
                onChange={(e) => {
                  // const utcDate = new Date(
                  //     Date.UTC(
                  //       e.target.value.getFullYear(),
                  //       e.target.value.getMonth(),
                  //       e.target.value.getDate()
                  //     )
                  //   );
                  setDate(e.target.value);
                }}
                showIcon
                minDate={minimumDate}
                maxDate={maximumDate}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
            </div>
            {enabledStoreLoad && (
              <div className="flex justify-content-center align-items-end mb-1 ml-2">
                <Button
                  label={"Check Load"}
                  onClick={() => checkStoreLoad()}
                  className=" text-xl w-full border-round-xl border-none cursor-pointer"
                ></Button>
              </div>
            )}
          </div>
        </div>
      )}
      <AdditionalInfoDiscountEdit
        additionalInfoDiscountEditModalVisible={
          additionalInfoDiscountEditModalVisible
        }
        setAdditionalInfoDiscountEditModalVisible={
          setAdditionalInfoDiscountEditModalVisible
        }
        sendDataToAdditionalInfoDiscountEdit={receiveDataFromCustomAmountModal}
        storeId={storeId}
        discountAmountPreviousValue={discountAmountPreviousValue}
        enabledAmountRoundOff={enabledAmountRoundOff}
      />
      <AdditionalInfoChargesEdit
        additionalInfoChargesEditModalVisible={
          additionalInfoChargesEditModalVisible
        }
        setAdditionalInfoChargesEditModalVisible={
          setAdditionalInfoChargesEditModalVisible
        }
        sendDataToAdditionalInfoChargesEdit={
          receiveDataFromCustomChargeAmountModal
        }
        storeId={storeId}
        chargeAmountPreviousValue={chargeAmountPreviousValue}
        storeLocalData={storeLocalData}
        enabledAmountRoundOff={enabledAmountRoundOff}
      />
      <OfferMessageModal
        setModalVisible={setMessageDisplay}
        modalVisible={messageDisplay}
        messageText={messageText}
      />
      <StoreLoadModal
        storeLoadModalVisible={storeLoadModalVisible}
        setStoreLoadModalVisible={setStoreLoadModalVisible}
        storeLoadData={storeLoadData}
      />
    </div>
  );
};

export default AdditionalInfo;
